module.exports = __webpack_public_path__ + "img/wx_Scan.039ad87b.png";